import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "getItemAttributes", "getItemHref", "getItemLabel", "onItemClick", "getItemOnClick", "getItemRef", "getItemTagName", "invert", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { IconChevronRight } from '@carnica/graphics';
import styles from "./styles.pcss";
import { composePreparedProps } from "./utils";
import { BreadCrumbsItem } from "./BreadCrumbsItem";
var cnBreadCrumbs = cnBem('breadcrumbs', styles);
var BreadCrumbsRender = function BreadCrumbsRender(props, ref) {
  var _composePreparedProps = composePreparedProps(props),
    _composePreparedProps2 = _composePreparedProps.items,
    items = _composePreparedProps2 === void 0 ? [] : _composePreparedProps2,
    getItemAttributes = _composePreparedProps.getItemAttributes,
    getItemHref = _composePreparedProps.getItemHref,
    getItemLabel = _composePreparedProps.getItemLabel,
    onItemClick = _composePreparedProps.onItemClick,
    getItemOnClick = _composePreparedProps.getItemOnClick,
    getItemRef = _composePreparedProps.getItemRef,
    getItemTagName = _composePreparedProps.getItemTagName,
    invert = _composePreparedProps.invert,
    className = _composePreparedProps.className,
    otherProps = _objectWithoutProperties(_composePreparedProps, _excluded);
  var handleClick = function handleClick(item) {
    return function (e) {
      var _getItemOnClick;
      onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(item, e);
      (_getItemOnClick = getItemOnClick(item)) === null || _getItemOnClick === void 0 ? void 0 : _getItemOnClick(e);
    };
  };
  return /*#__PURE__*/React.createElement("ul", _extends({
    className: cnBreadCrumbs(null, [className]),
    ref: ref
  }, otherProps, {
    "data-t-id": "components-BreadCrumbs"
  }), items === null || items === void 0 ? void 0 : items.map(function (item, i) {
    var attributes = _objectSpread({}, getItemAttributes(item) || {});
    return /*#__PURE__*/React.createElement("li", {
      className: cnBreadCrumbs('item-wrapper'),
      key: cnBreadCrumbs('item', {
        i: i
      })
    }, /*#__PURE__*/React.createElement(BreadCrumbsItem, _extends({}, attributes, {
      className: cnBreadCrumbs('item', [attributes.className]),
      href: getItemHref(item),
      invert: invert,
      label: getItemLabel(item),
      onClick: handleClick(item),
      ref: getItemRef(item),
      tagName: getItemTagName(item)
    })), i !== items.length - 1 && /*#__PURE__*/React.createElement(IconChevronRight, {
      customColor: "var(--bread-crumbs-divider-icon-color-".concat(invert ? 'invert' : 'default', ")"),
      size: "xs"
    }));
  }));
};
export var BreadCrumbs = /*#__PURE__*/forwardRef(BreadCrumbsRender);